module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point2_1-579b8847709d99ac0027694f676feecc.jpg";